import { createComponent } from 'react-fela'
import theme from 'design-framework/utils/base-ui-theme'

const __placeHolder = ({
	height = 'auto',
	width = 'auto',
	customStyles = {},
	animationDelay,
}) => ({
	animationFillMode: 'forwards',
	animationTimingFunction: 'linear',
	animationName: {
		'0%': { backgroundPosition: '-1000px 0' },
		'100%': { backgroundPosition: '1000px 0' },
	},
	animationIterationCount: 'infinite',
	animationDuration: `${Number.parseInt(animationDelay, 10) || 2}s`,
	background: `linear-gradient(to right, ${
		theme.primary(theme).shimmerColor
	} 0%, ${theme.colors.lightGrey3} 25%, ${
		theme.primary(theme).shimmerColor
	} 35%)`,
	backgroundSize: '1000px 100%',
	height,
	width,
	borderRadius: '4px',
	extend: {
		condition: Object.keys(customStyles).length,
		style: customStyles,
	},
})

export const __animatingFrame = {
	color: 'transparent',
	border: '1px solid #F5F5F5',
	animationFillMode: 'forwards',
	animationTimingFunction: 'linear',
	animationName: {
		'0%': { backgroundPosition: '0px 0' },
		'100%': {
			backgroundPosition: 'calc((100vw - 40px) / 2) 0',
		},
	},
	animationIterationCount: 'infinite',
	background: `linear-gradient(to right, ${
		theme.primary(theme).shimmerColor
	} 0%, ${theme.colors.lightGrey3} 25%, ${
		theme.primary(theme).shimmerColor
	} 35%)`,
	animationDuration: '1s',
}

export const PlaceHolder = createComponent(__placeHolder)
